import unescape from 'lodash/unescape';
import React from 'react';
import PropTypes from 'prop-types';
import IconInfo from '@spothero/icons/info';
import TextButton from '@spothero/ui/text-button';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import DestinationSchema from 'destination/DestinationSchema';
import SearchBreadcrumbsDesktop from '../breadcrumbs/SearchBreadcrumbsDesktop';
import SpotListAvailabilityDesktop from '../spot-list/SpotListAvailabilityDesktop';

const DestinationFeatureDesktop = ({
    breadcrumbs,
    destination,
    city,
    isFetchComplete,
    numSpots,
    onShowInfoModal,
    isMonthly,
    showEventList,
    onToggleEventList,
}) => {
    const {title, description} = destination;
    const displayTitle = `${unescape(title)} ${
        isMonthly ? 'Monthly ' : ''
    }Parking`;
    const hasEvents = Boolean(
        destination.has_upcoming_events &&
            destination.events &&
            destination.events.length > 0
    );

    return (
        <div className="DestinationFeature">
            <div className="detail">
                <SearchBreadcrumbsDesktop data={breadcrumbs} />
                <div itemScope itemType="http://schema.org/Place">
                    <h1 className="feature-heading">
                        <span>{displayTitle}</span>
                        <meta itemProp="name" content={unescape(title)} />
                        {destination && description && (
                            <TextButton
                                className="feature-info-link"
                                onClick={onShowInfoModal}
                            >
                                <IconInfo />
                            </TextButton>
                        )}
                    </h1>
                    <DestinationSchema destination={destination} city={city} />
                </div>
                <SpotListAvailabilityDesktop
                    isFetchComplete={isFetchComplete}
                    numSpots={numSpots}
                    showEventsCTA={hasEvents}
                    showEventList={showEventList}
                    onToggleEventList={onToggleEventList}
                />
            </div>
        </div>
    );
};

DestinationFeatureDesktop.propTypes = {
    breadcrumbs: PropTypes.object.isRequired,
    destination: PropTypes.shape(DESTINATION_DATA).isRequired,
    city: PropTypes.object.isRequired,
    isFetchComplete: PropTypes.bool.isRequired,
    isMonthly: PropTypes.bool.isRequired,
    showEventList: PropTypes.bool,
    numSpots: PropTypes.number.isRequired,
    onShowInfoModal: PropTypes.func.isRequired,
    onToggleEventList: PropTypes.func.isRequired,
};

export default DestinationFeatureDesktop;
